const AppRoutes = {
    loginPath: '/login',
    logoutPath: '/logout',
    unauthorizedPath: '/unauthorized',
    rootPath: '/',
    loginSuccessfullPath: '/login-successful',
    viewClientPath: '/client/:clientId',
    addClientPath: '/client',
};

export default AppRoutes;
